import angular from 'angular';
import './profile.scss';

import { AddressPaneComponent } from './address_pane.component';
import { AddressesComponent } from './addresses.component';
import { CreditCardPaneComponent } from './credit_card_pane.component';
import { CreditCardsComponent } from './credit_cards.component';
import { PasswordComponent } from './password.component';
import { ProfileComponent } from './profile.component';

export const ProfileModule = angular
    .module('profileModule', [])
    .component('addressPane', AddressPaneComponent)
    .component('addresses', AddressesComponent)
    .component('creditCardPane', CreditCardPaneComponent)
    .component('creditCards', CreditCardsComponent)
    .component('password', PasswordComponent)
    .component('profile', ProfileComponent)
    .name;
